import ReactTooltip from "react-tooltip";

let scheduled = false;

/**
 * Coalesces react-tooltip rebinds into one call per frame. Swatches that mount
 * asynchronously (brand colors, image colors) each request a rebuild; batching
 * means a single rebind runs after the whole batch has committed.
 */
export const scheduleTooltipRebuild = (): void => {
  if (scheduled) return;
  scheduled = true;

  const run = () => {
    scheduled = false;
    ReactTooltip.rebuild();
  };

  if (typeof requestAnimationFrame === "function") {
    requestAnimationFrame(run);
  } else {
    setTimeout(run, 0);
  }
};
